import React from 'react';

import { FiAward, FiTarget } from 'react-icons/fi';
import SisterConcerms from '../AboutUs/SisterConcerms';
import Achievements from '../AboutUs/Achievements';
import AboutBanner from '../AboutUs/AboutBanner';

const MissionVision = () => {
  return (
    <div>
      {/* Banner */}
      <AboutBanner text={"Mission Vision"} des={"Delivering excellence across technology, travel, and education. Guided by trust and innovation to create sustainable value for all."}></AboutBanner>

      <div className="about-us-section">
        {/* Mission & Vision - Added id="mission-vision" */}
        <section id="mission-vision" className="mission-vision">
          <div className="box mission">
            <div className="w-16 h-16 bg-sky-500/20 rounded-xl flex items-center justify-center mb-8">
              <FiTarget size={32} />
            </div>
            <h3 className="mt-3">Our Mission</h3>
            <p>
              IUG is a Business Platform dedicated to making a difference by supporting innovative new businesses and empowering entrepreneurs with the tools, resources, and guidance they need to succeed.
            </p>
          </div>

          <div className="box vision">
            <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mb-8">
              <FiAward size={32} />
            </div>
            <h3 className="mt-3">Our Vision</h3>
            <p>
              To become a leading business platform that drives sustainable and innovative business models, empowers non-supported startup entrepreneurs, contributes to economic and social development, and creates opportunities that help reduce unemployment while building a stronger and more inclusive future.
            </p>
          </div>
        </section>
        {/* Achievements */}
        <Achievements></Achievements>
        {/* Sister Concern */}
        <SisterConcerms></SisterConcerms>

      </div>
    </div>
  );
};

export default MissionVision;